"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateWorkspaceListing = exports.TemplateWorkspaceData = exports.GetWorkspaceResponse = exports.WorkspaceRole = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.WorkspaceRole = zod_1.z.enum(['owner', 'admin', 'contributor']);
const WorkspaceMember = zod_1.z.object({
    id: common_1.Uuid,
    name: zod_1.z.string(),
    avatar: zod_1.z.string().nullable(),
    role: exports.WorkspaceRole,
});
exports.GetWorkspaceResponse = zod_1.z.object({
    name: zod_1.z.string(),
    id: common_1.Uuid,
    members: zod_1.z.array(WorkspaceMember),
});
// used for creating/updating workspaces by staff
exports.TemplateWorkspaceData = zod_1.z.object({
    code: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    icon: zod_1.z.string(),
    active: zod_1.z.boolean(),
    sequence: common_1.IntegerId,
    workspaceId: common_1.Uuid,
});
// when returning to a non-staff user
exports.TemplateWorkspaceListing = exports.TemplateWorkspaceData.omit({
    active: true,
    workspaceId: true,
    sequence: true,
});
